export class Page {
  constructor(
    public readonly itemsPerPage: number,
    public readonly page: number
  ) {}
}
